export enum BuyerTypeEnum {
  GDO = 'gdo',
  STORE = 'store',
  CSF = 'csf'
}
